import {
	Icon,
	IconEditMass,
	IconForbidden,
	IconSwitch,
	IconTimelineAlt,
} from '@flixbus/honeycomb-icons-react';

import CrewMemberActionLog from './components/CrewMemberActionLog';
import HoldDowns from './components/Info/HoldDowns';
import PersonalTimeline from './components/PersonalTimeline';
import Unavailability from './components/Unavailability';

export const TABS_CONFIG = new Map(
	Object.entries({
		timeline: {
			label: 'Timeline View',
			icon: <Icon InlineIcon={IconTimelineAlt} />,
			tabId: 'timeline',
			panelId: 'timeline-panel',
			component: <PersonalTimeline />,
		},
		unavailablity: {
			label: 'Unavailability',
			icon: <Icon InlineIcon={IconForbidden} />,
			tabId: 'unavailability',
			panelId: 'unavailability-panel',
			component: <Unavailability />,
		},
		holdDowns: {
			label: 'Hold downs',
			icon: <Icon InlineIcon={IconSwitch} />,
			tabId: 'holdDowns',
			panelId: 'holdDowns-panel',
			component: <HoldDowns />,
		},
		actionLog: {
			label: 'Actions log',
			icon: <Icon InlineIcon={IconEditMass} />,
			tabId: 'actionslog',
			panelId: 'actionslog-panel',
			component: <CrewMemberActionLog />,
		},
	})
);
